<template>
  <div class="">
    <FormUser
      v-show="form_user_is_visible && isAdmin"
      :user="user_selected"
      :mode="mode_form"
      @close-modal="form_user_is_visible = !form_user_is_visible"
    />
    <DeleteUser
      v-show="delete_user_is_visible && isAdmin"
      :name="user_delete_name"
      :user_id="user_delete_id"
      @deleted="efetiveDeletedUser"
      @close="delete_user_is_visible = false"
    />
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <h3>{{is_pt_br  ? 'Usuários cadastrados' : 'Users registereds'}} ({{ usersList.length }})</h3>
        <button
        v-show="isAdmin"
          @click.prevent="handleNewUser()"
          class="ml-3 btn btn-outline-dark"
        >
          + {{is_pt_br ?  'Usuária' : 'User'}}
        </button>
      </div>
    </div>

    <div class="row px-4 mt-3">
      <Table class="col-12 p-0">
        <template v-slot:header>
          <tr>
            <th>{{is_pt_br ? "Usuário" : "User"}}</th>
            <th>Email </th>
            <th>Admin.</th>
            <th>{{is_pt_br ? "Ações" : "Actions"}}</th>
          </tr>
        </template>
        <template>
          <tr v-for="item in usersList" :key="item.id">
            <td>
              {{ item.username }}
              <small v-show="userId === item.id">(você)</small>
            </td>
            <td class="text-center">{{ item.email }}</td>
            <td>
              <div style="width: 100%" class="d-flex justify-content-center">
                <i
                  class="icon"
                  :class="item.is_admin ? 'icon-done' : 'icon-close'"
                ></i>
              </div>
            </td>
            <td class="d-flex justify-content-center">
              <button class="btn" @click.prevent="handleDeleteUser(item)" :disabled="!isAdmin">
                <i class="icon icon-delete-outlined"></i>
              </button>
              <button class="btn" @click.prevent="handleEditeUser(item)" :disabled="!isAdmin">
                <i class="icon icon-edite"></i>
              </button>
            </td>
          </tr>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import CardStone from "../../components/stone/CardStine.vue";
import Table from "../../components/utils/Table.vue";
import FormUser from "../../components/user/FormUser.vue";
import DeleteUser from "../../components/user/DeleteUser.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "StoneList",
  components: { CardStone, Table, FormUser, DeleteUser },
  data() {
    return {
      search_token: null,
      user_delete_name: "",
      user_delete_id: -1,
      delete_user_is_visible: false,
      form_user_is_visible: false,
      mode_form: "new-user",
      user_selected: {
        id: -1,
        username: "",
        email: "",
        password: "",
        password_confirm: "",
      },
    };
  },
  computed: {
    ...mapGetters("user", ["usersList", "userId", "isAdmin"]),
    is_pt_br(){
      return this.$store.getters.is_pt_br
    }
  },
  created() {
    this.setUsersList();
  },
  methods: {
    ...mapActions("user", ["setUsersList"]),
    ...mapActions("alertes", ["alertSuccess", "alertDanger"]),

    handleSearch(token) {
      this.search_token = token;
    },

    efetiveDeletedUser(error) {
      this.delete_user_is_visible = false;
      if (error)
        this.alertDanger(`Algo deu errado ao excluir o usuário: ${error}`);
      else this.alertSuccess("Usuário excluído com sucesso");
    },
    handleDeleteUser(index) {
      if (this.userId !== index.id) {
        this.user_delete_name = index.username;
        this.user_delete_id = index.id;
        this.delete_user_is_visible = true;
      }
    },
    handleNewUser() {
      (this.form_user_is_visible = !this.form_user_is_visible),
        (this.mode_form = "new-user");
      this.user_selected.username = "";
      this.user_selected.email = "";
    },
    handleEditeUser(item) {
      this.mode_form = "edite-user";
      this.user_selected.username = item.username;
      this.user_selected.email = item.email;
      this.user_selected.id = item.id;

      this.form_user_is_visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 20px;
  height: 20px;
}
.icon-delete-outlined {
  background-color: #c82333;
}
.icon-done {
  background-color: #28a745;
}
</style>
